'use strict';
function _typeof(e) {
  return (
    _typeof = 'function' == typeof Symbol &&
    'symbol' == typeof Symbol.iterator ? function (e) {
      return typeof e
    }
     : function (e) {
      return e &&
      'function' == typeof Symbol &&
      e.constructor === Symbol &&
      e !== Symbol.prototype ? 'symbol' : typeof e
    }
  ) (e)
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function')
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable ||
    !1,
    n.configurable = !0,
    'value' in n &&
    (n.writable = !0),
    Object.defineProperty(e, _toPropertyKey(n.key), n)
  }
}
function _createClass(e, t, r) {
  return t &&
  _defineProperties(e.prototype, t),
  r &&
  _defineProperties(e, r),
  Object.defineProperty(e, 'prototype', {
    writable: !1
  }),
  e
}
function _toPropertyKey(e) {
  e = _toPrimitive(e, 'string');
  return 'symbol' == _typeof(e) ? e : String(e)
}
function _toPrimitive(e, t) {
  if ('object' != _typeof(e) || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (void 0 === r) return ('string' === t ? String : Number) (e);
  r = r.call(e, t || 'default');
  if ('object' != _typeof(r)) return r;
  throw new TypeError('@@toPrimitive must return a primitive value.')
}
function _callSuper(e, t, r) {
  return t = _getPrototypeOf(t),
  _possibleConstructorReturn(
    e,
    _isNativeReflectConstruct() ? Reflect.construct(t, r || [], _getPrototypeOf(e).constructor) : t.apply(e, r)
  )
}
function _possibleConstructorReturn(e, t) {
  if (t && ('object' === _typeof(t) || 'function' == typeof t)) return t;
  if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
  return _assertThisInitialized(e)
}
function _isNativeReflectConstruct() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
    }))
  } catch (e) {
  }
  return (_isNativeReflectConstruct = function () {
    return !!e
  }) ()
}
function _getPrototypeOf(e) {
  return (
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
      return e.__proto__ ||
      Object.getPrototypeOf(e)
    }
  ) (e)
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return e
}
function _inherits(e, t) {
  if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function');
  e.prototype = Object.create(
    t &&
    t.prototype,
    {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }
  ),
  Object.defineProperty(e, 'prototype', {
    writable: !1
  }),
  t &&
  _setPrototypeOf(e, t)
}
function _setPrototypeOf(e, t) {
  return (
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
      return e.__proto__ = t,
      e
    }
  ) (e, t)
}
function handleSwipe(e, t) {
  var n = t.onSwipeRight,
  o = t.onSwipeLeft,
  i = (
    e.addEventListener(
      'touchstart',
      function (e) {
        i = e.touches[0].clientX,
        l = e.touches[0].clientY
      },
      !1
    ),
    e.addEventListener(
      'touchmove',
      function (e) {
        var t,
        r;
        null !== i &&
        null !== l &&
        (
          t = e.touches[0].clientX,
          r = e.touches[0].clientY,
          t = i - t,
          r = l - r,
          Math.abs(t) > Math.abs(r) &&
          (0 < t ? (e.preventDefault(), o) : (e.preventDefault(), n)) (),
          l = i = null
        )
      },
      !1
    ),
    null
  ),
  l = null
}
customElements.get('product-slider-component') ||
(
  isTouchDevice = 'ontouchstart' in window ||
  0 < navigator.MaxTouchPoints ||
  0 < navigator.msMaxTouchPoints,
  ProductSliderComponent = function () {
    function t() {
      var e;
      return _classCallCheck(this, t),
      (e = _callSuper(this, t))._elImageSlides = null,
      e._elCardSlides = null,
      e.dirty = !1,
      e.element = _assertThisInitialized(e),
      e.elMediaContainer = e.querySelector('.card-product-slider'),//图片集合
      e.isCollectionTemplate = document.querySelector('.template-collection'),
      e.isGrapheneSearchTemplate = document.querySelector('.template-name-search'),
      e.handleSlide(),
      e
    }
    return _inherits(t, SliderComponent),
    _createClass(
      t,
      [
        {
          key: 'elCardSlides',
          get: function () {
            return this._elCardSlides ||
            (
              this._elCardSlides = this.querySelectorAll('.product__media-item')//图片集合的子元素
            ),
            this._elCardSlides
          }
        },
        {
          key: 'handleSlide',
          value: function () {
            var t = this,
            e = this.querySelector('.slider-button--next'),//向右切换的按钮元素
            f = t.querySelector('.product__media-item.first-img'), //包裹第一张产品图片的 li
            l = t.querySelectorAll('.product__media-item'), //包裹产品图片的 li
            e = (
              e &&
              e.addEventListener(
                'click',
                function (e) {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, 1)
                }
              ),   
              e.addEventListener(
                'keydown',
                function (e) {
                  if (e.key === 'Enter' || e.key==' ') {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, 1)
                  }
                }
              ),       
              e.addEventListener(
                'blur',
                function (e) {
                  e.preventDefault();
                  l?.forEach(i => i?.classList.remove('is-active'));
                  f?.classList.add('is-active');
                }
              ),
              this.querySelector('.slider-button--prev')//向左切换的按钮元素
            ),
            e = (
              e &&
              e.addEventListener(
                'click',
                function (e) {
                  e.preventDefault(),
                  t.dirty = !0,
                  plusSlides(t, - 1)
                }
              ),
              e.addEventListener(
                'keydown',
                function (e) {
                  if (e.key === 'Enter' || e.key==' ') {
                    e.preventDefault(),
                    t.dirty = !0,
                    plusSlides(t, - 1)
                  }
                }
              ),
              e.addEventListener(
                'blur',
                function (e) {
                  e.preventDefault();
                  l?.forEach(i => i?.classList.remove('is-active'));
                  f?.classList.add('is-active');
                }
              ),
              this.querySelector('.card-product-slider')
            ),
            r = this.closest('.card__media');
            e &&
            1 < this.elCardSlides.length &&
            (
              null == this.isCollectionTemplate &&
              null == this.isGrapheneSearchTemplate ||
              handleSwipe(
                e,
                {
                  onSwipeRight: function () {
                    return plusSlides(t, - 1)
                  },
                  onSwipeLeft: function () {
                    return plusSlides(t, 1)
                  }
                }
              ),
              r.addEventListener(
                'mouseenter',
                function (e) {
                  t.dirty ||
                  isTouchDevice ||
                  plusSlides(t, 1)
                }
              ),
              r.addEventListener(
                'mouseleave',
                function (e) {
                  t.dirty ||
                  isTouchDevice ||
                  plusSlides(t, - 1)
                }
              )
            )
          }
        }
      ]
    ),
    t
  }(),
  customElements.define('product-slider-component', ProductSliderComponent)
);
var isTouchDevice,
ProductSliderComponent,
slideIndexNumber = 1;
function plusSlides(e, t) {
  var e = e.closest('product-slider-component'),
  r = e.querySelectorAll('.slider-pagination .dot'),
  r = Array.from(r).findIndex(function (e) {
    return e.classList.contains('is-active')
  }) + 1 + t,
  n = e.elCardSlides.length;
  n < r ? r = 1 : r < 1 &&
  (r = n),
  showSlides(r, e, Math.sign(t))
}
function currentSlide(e, t) {
   e = e.parentElement.parentElement;
  showSlides(slideIndexNumber = t, e, 1)
}
function showSlides(e, t, r) {
  var n,
  o = (t = t.closest('product-slider-component')).elCardSlides,
  i = t.querySelectorAll('.slider-pagination .dot');
  for (
    e > o.length &&
    (slideIndexNumber = 1),
    e < 1 &&
    (slideIndexNumber = o.length),
    n = 0;
    n < o.length;
    n++
  ) o[n].classList.remove('is-active');
  for (n = 0; n < i.length; n++) i[n].className = i[n].className.replace(' is-active', '');
  var t = o[e - 1],
  l = 1 == r ? o[e % o.length] : o[e - 2 < 0 ? o.length - 1 : e - 2];
  l.querySelector('.lazyload') &&
  t.querySelector('img').addEventListener(
    'load',
    function () {
      l.querySelector('.lazyload').classList.add('lazypreload')
    },
    {
      once: !0
    }
  ),
  null != (r = t.querySelector('.lazyload')) &&
  r.setAttribute('fetchpriority', 'high'),
  t.classList.add('is-active'),
  i[e - 1].className += ' is-active'
}

class ColorChangeComponent extends HTMLElement {
  constructor() {
    super();
    this.pageStart = 0;
    this.pageHistory = [0];
    this._lastWidth = 0;
    this._itemStep = 0;
    this._resizeTimer = null;

    const swatchContainer = this.querySelector("fieldset");
    const hidecountbtn = this.querySelector(".over-swatch-btn");
    var countnum = hidecountbtn && hidecountbtn.querySelector(".more-swatch")
    const swathitem = this.querySelectorAll('.s-item');
    const swatchinput = this.querySelectorAll('.swatch-input__input');
    const swatchbtn = this.querySelectorAll('.swatch');
     var backtoleft = this.querySelector('.backtoleft');
    for (const swinput of swatchinput) {
      swinput.addEventListener('click', this.onClicktoCoverImage2.bind(this));
    }
    for (const swatch of swatchbtn) {
      swatch.addEventListener('click', this.onClicktoCoverImage.bind(this));
      swatch.addEventListener('mouseenter', this.onHovertoCoverImage.bind(this)); 
      swatch.addEventListener('keydown', this.onkeydownSwatch.bind(this)); 
    }
    if (hidecountbtn) hidecountbtn.addEventListener('click', this.onShowMoreColor.bind(this));
    if(backtoleft)backtoleft.addEventListener('click', this.onshowOriginColor.bind(this))

    // DE/FR cards: remap swatch file names to English theme Files
    if (typeof window.applyEnglishItemSwatches === 'function') {
      window.applyEnglishItemSwatches(this);
    }

    if (swatchContainer) {
      const resizeObserver = new ResizeObserver(() => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          const containerWidth = swatchContainer.clientWidth;
          if (!containerWidth) return;
          if (containerWidth === this._lastWidth) return;
          this._lastWidth = containerWidth;
          this.init(swatchContainer, swathitem, hidecountbtn, countnum);
        }, 200);
      });
      resizeObserver.observe(swatchContainer);
    }
    }

  getSwatchGap() {
    const list = this.querySelector('.item-swatch');
    if (!list) return 4;
    const gap = parseFloat(getComputedStyle(list).gap);
    return Number.isFinite(gap) ? gap : 4;
  }

  getItemStep(items) {
    if (this._itemStep > 0) return this._itemStep;
    const item = (items || []).find((el) => el && !el.classList.contains('d-none')) || (items && items[0]);
    const width = item && item.offsetWidth ? item.offsetWidth : 30;
    this._itemStep = width + this.getSwatchGap();
    return this._itemStep;
  }

  calculateSwatches(containerWidth, swatchWidth, controlCount = 1) {
    const reserved = swatchWidth * controlCount;
    return Math.max(1, Math.floor((containerWidth - reserved) / swatchWidth));
  }

  resetOverflowState() {
    const list = this.querySelector('.item-swatch');
    this.querySelectorAll('.s-item').forEach((item) => {
      item.classList.remove('d-none', 'd-block');
    });
    const moreBtn = this.querySelector('.over-swatch-btn');
    if (moreBtn) {
      moreBtn.classList.add('hidden');
      moreBtn.classList.remove('d-none');
      moreBtn.parentElement && moreBtn.parentElement.classList.remove('d-none');
    }
    const back = this.querySelector('.backtoleft');
    if (back) back.classList.add('d-none');
    if (list) {
      list.style.left = '';
      list.style.removeProperty('--to-left');
      list.classList.remove('scrolled');
    }
    const fieldset = this.querySelector('fieldset');
    if (fieldset) fieldset.style.width = '';
  }

  init(swatchContainer,swathitem,hidecountbtn,countnum){
    this.pageStart = 0;
    this.pageHistory = [0];
    this._itemStep = 0;
    this.resetOverflowState();
    const container = swatchContainer || this.querySelector('fieldset');
    const items = swathitem && swathitem.length ? Array.from(swathitem) : Array.from(this.querySelectorAll('.s-item'));
    if (!container || !items.length) return;
    this._lastWidth = container.clientWidth || this._lastWidth;
    this.renderPage(container, items, hidecountbtn, countnum);
  }

  renderPage(swatchContainer, swathitem, hidecountbtn, countnum) {
    const container = swatchContainer || this.querySelector('fieldset');
    const items = swathitem && swathitem.length ? Array.from(swathitem) : Array.from(this.querySelectorAll('.s-item'));
    const moreBtn = hidecountbtn || this.querySelector('.over-swatch-btn');
    const moreCount = countnum || (moreBtn && moreBtn.querySelector('.more-swatch'));
    const list = this.querySelector('.item-swatch');
    if (!container || !items.length || !list) return;

    const containerWidth = container.clientWidth;
    if (!containerWidth) return;

    items.forEach((item) => item.classList.remove('d-none', 'd-block'));
    this._itemStep = 0;
    const itemStep = this.getItemStep(items);
    const start = Math.max(0, Math.min(this.pageStart || 0, items.length - 1));
    const remaining = items.length - start;
    const hasBack = start > 0;
    let controls = hasBack ? 1 : 0;
    let fit = this.calculateSwatches(containerWidth, itemStep, controls);
    if (remaining > fit) controls += 1;
    fit = this.calculateSwatches(containerWidth, itemStep, controls);
    fit = Math.min(Math.max(1, fit), remaining);

    const end = start + fit;
    items.forEach((item, index) => {
      item.classList.toggle('d-none', index < start || index >= end);
    });

    const hiddenCount = items.length - end;
    if (moreBtn && moreCount) {
      const moreLi = moreBtn.parentElement;
      if (hiddenCount > 0) {
        moreBtn.classList.remove('hidden', 'd-none');
        if (moreLi) moreLi.classList.remove('d-none');
        moreCount.textContent = '+' + hiddenCount;
        moreCount.setAttribute('more-swatch-count', String(fit));
        moreCount.setAttribute('hide-swatch-count', String(hiddenCount));
      } else {
        moreBtn.classList.add('hidden');
        moreBtn.classList.remove('d-none');
        if (moreLi) moreLi.classList.add('d-none');
      }
    }

    this.syncBackButton(list, items[start], hasBack);
    list.style.left = '';
    list.style.removeProperty('--to-left');
    list.classList.toggle('scrolled', hasBack);
  }

  syncBackButton(list, firstVisible, hasBack) {
    let back = list.querySelector('.backtoleft');
    if (!hasBack) {
      if (back) back.classList.add('d-none');
      return;
    }

    if (!back) {
      const uid = (this.querySelector('.swatch-input__input') || {}).id || 'swatch';
      back = document.createElement('li');
      back.className = 'backtoleft';
      back.innerHTML = `<label>
              <svg aria-hidden="true" role="img" aria-labelledby="backleft-${uid}" tabindex="0" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: none;">
                  <title id="backleft-${uid}">button to view more</title>
                  <path d="M0.999541 1.40417L5.11719 5.52182L0.99954 9.63947" stroke="#B4B4B4" stroke-width="1.23529"></path>
              </svg>
              <span class="sr-only">Back to view left colors</span>
              </label>
          `;
      back.addEventListener('click', (event) => this.onshowOriginColor(event));
    }

    back.classList.remove('d-none');
    if (firstVisible && firstVisible.parentNode === list) {
      list.insertBefore(back, firstVisible);
    } else if (!back.parentNode) {
      list.insertBefore(back, list.firstChild);
    }
  }

  onshowOriginColor(event){
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.pageHistory.length > 1) {
      this.pageHistory.pop();
      this.pageStart = this.pageHistory[this.pageHistory.length - 1];
    } else {
      this.pageStart = 0;
    }
    this.renderPage();
  }

  onShowMoreColor(event){
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const moreCount = event.currentTarget.querySelector('.more-swatch');
    const shown = Number(moreCount && moreCount.getAttribute('more-swatch-count')) || 0;
    if (shown <= 0) return;
    const nextStart = (this.pageStart || 0) + shown;
    if (nextStart === this.pageStart) return;
    this.pageHistory.push(nextStart);
    this.pageStart = nextStart;
    this.renderPage();
  }
  onClicktoCoverImage2(event) {
    const elElement = event.currentTarget;
    const labelElement = elElement.nextElementSibling;
    if (labelElement) {
      const swatchElement = labelElement.querySelector('.swatch');
      swatchElement.click();
    }
  }
  onClicktoCoverImage(event) {
    const elElement = event.currentTarget;
    const imgSrc = elElement.getAttribute('data-img');
    const parentWrapper = elElement.closest('.card-wrapper');
    const target_img = parentWrapper?.querySelector('.first-img img');

    elElement.setAttribute('tabindex', 0);

    // Missing data-img used to set src=null and show a broken image + alt text
    if (imgSrc && target_img && target_img.getAttribute('src') !== imgSrc) {
      target_img.setAttribute('src', imgSrc);
      target_img.setAttribute('srcset', imgSrc);
    }

    const parentLi = elElement.closest('.item-swatch');
    if (!parentLi) return;
    parentLi.querySelectorAll('.swatch').forEach((sibling) => {
      if (sibling !== elElement) sibling.setAttribute('tabindex', '-1');
    });
  }
  onHovertoCoverImage(event){
    const elElement = event.currentTarget;

    if(event.type=='mouseenter') {
      elElement.click();
    }
  }

  onkeydownSwatch(event){
              const elElement = event.currentTarget;
              const list = elElement.closest(".item-swatch");
              const visible = Array.from(list.querySelectorAll('.s-item .swatch')).filter((swatch) => {
                const item = swatch.closest('.s-item');
                return item && !item.classList.contains('d-none');
              });
              const current = visible.indexOf(elElement);
              const totalSize = visible.length;
              let nextIndex = current + 1;
              let prevIndex = current - 1;
              
              // 循环处理
              if (nextIndex >= totalSize) {
                  nextIndex = 0;
              }
              if (prevIndex < 0) {
                  prevIndex = totalSize - 1;
              }
  
              // 处理键盘事件
              if (event.key === 'Enter' || event.key==' ') {
                  this.click();
              }
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                  const nextLabel = visible[nextIndex];
                  if (nextLabel) {                   
                      nextLabel.focus();
                      nextLabel.click();
                  }
              }
              if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                  const prevLabel = visible[prevIndex];
                  if (prevLabel) {                   
                      prevLabel.focus();
                       prevLabel.click();
                  }
              }

  }

}
customElements.define('color-change-component', ColorChangeComponent);